export enum TermsActionsEnum {
    fetchTermsForStudymaterial = '[term] fetchTermsForStudymaterial',
    fetchTermsForStudymaterialSuccess = '[term] fetchTermsForStudymaterialSuccess',
    fetchTermsForStudymaterialFailed = '[term] fetchTermsForStudymaterialFailed',
}
